import {AiExtractorType, OpenAiServiceTier} from "./AiExtractor";

class AiModelPricing {
    constructor(
        public id?: string,
        public createdAt?: Date,
        public aiExtractorType?: AiExtractorType,
        public model?: string,
        public openAiServiceTier?: OpenAiServiceTier,
        public inputPricePerMillionTokens?: number,
        public cachedInputPricePerMillionTokens?: number,
        public cacheWriteInputPricePerMillionTokens?: number,
        public outputPricePerMillionTokens?: number,
        public webSearchPricePer1kCalls?: number
    ) {
    }

    public static fromPOJO(data: any) {
        if (!data) return null;

        const entity = new AiModelPricing();

        entity.id = data.id;
        entity.createdAt = data.createdAt;
        entity.aiExtractorType = data.aiExtractorType;
        entity.model = data.model;
        entity.openAiServiceTier = data.openAiServiceTier;
        entity.inputPricePerMillionTokens = data.inputPricePerMillionTokens;
        entity.cachedInputPricePerMillionTokens = data.cachedInputPricePerMillionTokens;
        entity.cacheWriteInputPricePerMillionTokens = data.cacheWriteInputPricePerMillionTokens;
        entity.outputPricePerMillionTokens = data.outputPricePerMillionTokens;
        entity.webSearchPricePer1kCalls = data.webSearchPricePer1kCalls;

        return entity;
    }
}

export default AiModelPricing;
